import React,{Component} from 'react';

import './Social.less';

const Social = ({style,mobile,data}) => {
  return (
    <div className={mobile ? 'social mobile' : 'social'} style={style}>
      <div className={mobile ? 'social-icons mobile' : 'social-icons'}>
      {
        data && data.social.filter(el => el.network != 'bandsintown').map(social => <a key={social.network} href={social.url} target="_blank" className='social-icon'><img src={`/img/netzwerke/${social.network}.svg`} /></a>)
      }
      </div>
    </div>
  )
}

export default Social



// WEBPACK FOOTER //
// ./src/components/Social.js